import { Injectable } from '@angular/core';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { Observable } from 'rxjs';
import {
  CreateRequest,
  EditRequest,
  GetAllRequestResponse,
  GetRequestsCountResponse,
  GetRequestToEditResponse,
  Request,
} from '../entities';
@Injectable()
export abstract class RequestsServices {
  /**
   * All Requests
   */
  abstract getAllRequests(companyId: string): Observable<GetAllRequestResponse>;

  /**
   * Create Requests
   * @param request is the body of a new request
   */
  abstract createRequest(request: CreateRequest): Observable<any>;

  /**
   * Export Requests
   * @param requests are the requests to export
   */
  abstract exportRequests(requests: Request[]): Observable<any>;

  /**
   * Edit Requests
   * @param id is the id of the request to edit
   * @param request is the new body of the request to edit
   */
  abstract editRequest(request: EditRequest): Observable<GetAllRequestResponse>;

  /**
   * Get My Requests
   */
  abstract myRequests(query: ApiQueryParams): Observable<GetAllRequestResponse>;

  /**
   * Get Request By Id
   */
  abstract getRequestById(
    requestId: string
  ): Observable<GetRequestToEditResponse>;

  /**
   * Get Requests Count
   */
  abstract getMyRequestsCount(
    userId: string
  ): Observable<GetRequestsCountResponse>;
}
